import { render } from "./PagamentiRuoli.vue?vue&type=template&id=4450ea0e&scoped=true"
import script from "./PagamentiRuoli.vue?vue&type=script&lang=js"
export * from "./PagamentiRuoli.vue?vue&type=script&lang=js"

import "./PagamentiRuoli.vue?vue&type=style&index=0&id=4450ea0e&scoped=true&lang=css"

import exportComponent from "/Users/francescoscialacqua/Sviluppo/emmet.client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4450ea0e"]])

export default __exports__